import React from 'react';

import './BodyManageAccount.scss';

const BodyManageAccount = (props) => {

    return (
            <div className="my-account">
                <h6>Details</h6>
                <div className="row">
                    <div className="col-md-6" style={{paddingLeft: '5px', paddingRight: '5px'}}>
                        <label style={{display: "inline", marginLeft: "0px"}}>Username</label>
                        <input disabled type="text" className="form-control" />
                    </div>

                    <div className="col-md-6">
                        <label style={{display: "inline", marginLeft: "5px"}}></label>
                        <input disabled type="text" className="form-control" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6" style={{paddingLeft: '5px', paddingRight: '5px'}}>
                        <label style={{display: "inline", marginLeft: "0px"}}>Password</label>
                        <input disabled type="text" className="form-control" />
                    </div>

                    <div className="col-md-6">
                        <label style={{display: "inline", marginLeft: "5px"}}>Password</label>
                        <input disabled type="text" className="form-control" />
                    </div>
                </div>
                <div className="row">
                    <div className='col-md-10'/>
                        <div className='col-md-2'>
                            <button style={{marginTop: '20px', width:'120px', padding:'6px'}}>Update</button>
                        </div>
                </div>
            </div>

    )
}

export default BodyManageAccount ;